import type { PinValidationRequest, ValidatedPinUser } from 'washday-sdk';
import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { updateUserByIdV2, validateUserPin } from '../../services/staff.service';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';

export const useUpdateUserById = (userId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (data: {
      email?: string;
      name?: string;
      phoneNumber?: string;
      currentPassword?: string;
      newPassword?: string;
      confirmNewPassword?: string;
    }) => {
      try {
        const res = await updateUserByIdV2(userId, data);
        if (!res?.data) {
          throw new Error('Oh no! Something went wrong while updating.');
        }
        return res.data;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    },
    onSuccess: async () => {
      return Promise.all([queryClient.invalidateQueries({
        queryKey: ['user', { userId: userId }],
      })]);
    }
  });
};


export const useValidateUserPIN = () => {
  return useMutation({
    mutationFn: async (data: PinValidationRequest) => {
      try {
        const res = await validateUserPin(data);
        if (!res?.data?.data) {
          throw new Error('Oh no! Something went wrong while validating PIN.');
        }
        return res.data.data as ValidatedPinUser;
      } catch (e: any) {
        console.log('error caught', e['response']?.data?.['errors']);
        backendErrorsHandler(e);
        throw e;
      }
    }
  });
};
